import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { required, requiredSelection } from '@/lib/rule';
import { useDynamicListComposable } from '@/composables/useDynamicList';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';

export type LawsAndRegulationsForm = {
  lawRegulationIds: string[];
  extractionTargets: ('section3Cas' | 'section3Material' | 'section15')[];
  title: string;
  description: string;
  dbt_types?: string[];
  law_ids?: number[];
  regulation_ids?: number[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateByLawsAndRegulationsForm',
  props: {
    step: null,
    form: null
  },
  emits: ["update:form"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:form', form: LawsAndRegulationsForm): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  step: number;
  form: LawsAndRegulationsForm;
};

const m = defineMessages({
  selectLawRegulation: '対象法令 / 細則を選択してください',
  selectDetailedConditions: '詳細条件を選択してください',
  enterTitleAndDescription: 'タイトルと概要を記入してください',
  title: 'タイトル',
  enterTitle: 'タイトルを入力...',
  enterDescription: '概要を入力...',
  clickToCreateChecklist:
    '「実行する」をクリックすると、以下の項目でチェックリストを作成します。',
  detailedConditions: '詳細条件',
});





const {
  lawRegulationList,
  getLawRegulationText,
  includesShowSection3Cas,
  includesShowSection3Material,
} = useDynamicListComposable();
const extractionTargetText = {
  section3Cas: '3章 CAS番号から抽出',
  section3Material: '3章 物質名称から抽出',
  section15: '15章 細則に該当するものを抽出',
} as const;

const lawRegulationIds = ref(props.form.lawRegulationIds);
const extractionTargets = ref(props.form.extractionTargets);
const title = ref(props.form.title);
const description = ref(props.form.description);

const dbt_types = computed((): string[] => {
  const types: string[] = [];
  if (extractionTargets.value.includes('section3Cas')) {
    types.push('cas');
  }
  if (extractionTargets.value.includes('section3Material')) {
    types.push('material');
  }
  if (extractionTargets.value.includes('section15')) {
    types.push('regulation');
  }
  return types;
});

const law_ids = computed((): number[] => {
  return [
    ...new Set(
      lawRegulationIds.value.map((id: string) => parseInt(id.split('-')[0], 10))
    ),
  ];
});

const regulation_ids = computed((): number[] => {
  return lawRegulationIds.value.map((id: string) => {
    const regulationId = id.split('-')[1];
    return regulationId === 'all'
      ? parseInt(id.split('-')[0], 10)
      : parseInt(regulationId, 10);
  });
});

watch(
  () => props.form,
  (newForm) => {
    lawRegulationIds.value = newForm.lawRegulationIds;
    extractionTargets.value = newForm.extractionTargets;
    title.value = newForm.title;
    description.value = newForm.description;
  },
  { deep: true }
);

// 法令の選択変更時のチェックボックス制御
watch(lawRegulationIds, (newValue) => {
  // 法令の選択状態が変化したら表示しないチェックボックスの選択状態を解除する
  if (!includesShowSection3Cas(newValue)) {
    extractionTargets.value = extractionTargets.value.filter(
      (target) => target !== 'section3Cas'
    );
  }
  if (!includesShowSection3Material(newValue)) {
    extractionTargets.value = extractionTargets.value.filter(
      (target) => target !== 'section3Material'
    );
  }
  if (newValue.length === 0) {
    extractionTargets.value = [];
  }
});

// 全ての値の変更を監視して更新
watch([lawRegulationIds, extractionTargets, title, description], () => {
  emit('update:form', {
    ...props.form,
    lawRegulationIds: lawRegulationIds.value,
    extractionTargets: extractionTargets.value,
    title: title.value,
    description: description.value,
    dbt_types: dbt_types.value,
    law_ids: law_ids.value,
    regulation_ids: regulation_ids.value,
  });
});

return { __sfc: true,m, props, emit, lawRegulationList, getLawRegulationText, includesShowSection3Cas, includesShowSection3Material, extractionTargetText, lawRegulationIds, extractionTargets, title, description, dbt_types, law_ids, regulation_ids, required, requiredSelection, sharedMessages }
}

})